var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileDevice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 151,
    viewBox: "0 0 97 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.2301 45.3208L48.5 56.084L37.7622 45.3208L27.8139 55.2998L38.5517 66.063L27.8139 76.8339L37.7622 86.8129L48.5 76.0497L59.2301 86.8129L69.1861 76.8339L58.4483 66.063L69.1861 55.2998L59.2301 45.3208Z",
    stroke: "#C94B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2998 2.3064H14.7002C7.85138 2.3064 2.2993 7.87561 2.2993 14.7456V136.254C2.2993 143.124 7.85138 148.694 14.7002 148.694H82.2998C89.1486 148.694 94.7007 143.124 94.7007 136.254V14.7456C94.7007 7.87561 89.1486 2.3064 82.2998 2.3064Z",
    stroke: "#C94B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8936 11.1245H15.1141C12.5998 11.1245 10.5615 13.1691 10.5615 15.6912V124.884C10.5615 127.406 12.5998 129.451 15.1141 129.451H81.8936C84.4079 129.451 86.4462 127.406 86.4462 124.884V15.6912C86.4462 13.1691 84.4079 11.1245 81.8936 11.1245Z",
    stroke: "#C94B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9462 138.469H59.0538",
    stroke: "#C94B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDevice);
export default __webpack_public_path__ + "static/media/mobile_device.d39587833ddf18e04efb6455cb75f38c.svg";
export { ForwardRef as ReactComponent };